window.madSingleProductImageGallery = {
  initialized: false,
  lastHeight: null,
  baseline: {
    adminBar: 0,
    navbar: 0
  }
};

$dependencyManager.addDependenciesCallback(['gsap', 'scrollTrigger'], () => {
  gsap.registerPlugin(ScrollTrigger);

  jQuery(document).ready(() => {
    if (window.madSingleProductImageGallery.initialized) return;

    const $galleryContainerCandidates = jQuery('.brz-column__items > div:has(.brz-woo-gallery), .brz-column__items .brz-woo-gallery');
    if (!$galleryContainerCandidates.length) {
      window.madSingleProductImageGallery.initialized = true;
      return;
    }

    const $imageGalleryContainer = $galleryContainerCandidates.first();
    const $imageGalleryParent = $imageGalleryContainer.parent();
    const $variationGallery = jQuery('.woo-variation-product-gallery');

    // --- Helpers -------------------------------------------------------------

    const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

    // Freeze a baseline (collapsed) height for fixed items at init/resize ONLY.
    const captureBaselines = () => {
      const $adminBar = jQuery('#wpadminbar');
      const $navbar   = jQuery('.mad-navbar__section');
      window.madSingleProductImageGallery.baseline.adminBar = $adminBar.length ? ($adminBar.outerHeight() || 0) : 0;
      window.madSingleProductImageGallery.baseline.navbar   = $navbar.length ? ($navbar.outerHeight()   || 0) : 0;
    };

    // Use baseline heights so mega-menu hover changes DON'T move the gallery.
    const getFixedTopOccupied = () => {
      const b = window.madSingleProductImageGallery.baseline;
      return (b.adminBar || 0) + (b.navbar || 0);
    };

    // Center the gallery within the visible area below the fixed baseline.
    const computeStickyTop = () => {
      const fixedTop = getFixedTopOccupied();
      const viewportH = window.innerHeight || jQuery(window).height();
      const elH = $imageGalleryContainer.outerHeight() || 0;

      const available = Math.max(0, viewportH - fixedTop);
      const centeredOffset = Math.max(0, (available - elH) / 2);

      return Math.round(fixedTop + centeredOffset);
    };

    const applyStickyTop = () => {
      const topVal = computeStickyTop();
      $imageGalleryContainer.css({
        position: 'sticky',
        top: `${topVal}px`,
        zIndex: 2
      });
    };

    const enableSticky = () => {
      applyStickyTop();
    };

    const disableSticky = () => {
      $imageGalleryContainer.css({
        position: '',
        top: '',
        zIndex: ''
      });
    };

    const refreshSticky = () => {
      if (isDesktop()) {
        enableSticky();
      } else {
        disableSticky();
      }
    };

    // --- Init ---------------------------------------------------------------
    captureBaselines();
    refreshSticky();

    // --- Variation / gallery height changes (recompute top with same baseline)
    window.madSingleProductImageGallery.lastHeight = $variationGallery.height();

    const maybeRecalcOnHeightChange = () => {
      const h = $variationGallery.height();
      if (window.madSingleProductImageGallery.lastHeight !== h) {
        window.madSingleProductImageGallery.lastHeight = h;
        if (isDesktop()) applyStickyTop();
      }
    };

    jQuery('.brz-woo-gallery, .brz-woo-gallery *').on('click', () => {
      maybeRecalcOnHeightChange();
      setTimeout(maybeRecalcOnHeightChange, 250);
      setTimeout(maybeRecalcOnHeightChange, 500);
      setTimeout(maybeRecalcOnHeightChange, 1000);
    });

    // Also observe for DOM-driven size changes of the gallery only
    if ('ResizeObserver' in window && $variationGallery.length) {
      try {
        const ro = new ResizeObserver(() => {
          maybeRecalcOnHeightChange();
        });
        ro.observe($variationGallery.get(0));
      } catch (e) { /* ignore */ }
    }

    // --- Resize/orientation: update BASELINES (real layout change), then sticky
    const debounce = (fn, wait) => {
      let t;
      return function () {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, arguments), wait);
      };
    };

    const handleResize = () => {
      captureBaselines();   // recalc baseline ONLY on true window resize/orientation
      refreshSticky();      // reapply sticky top using the new baseline
    };

    jQuery(window).on('resize orientationchange', debounce(handleResize, 150));

    // IMPORTANT: do NOT observe navbar/adminbar live height changes anymore,
    // because hover-mega increases height transiently. We want sticky top to stay put.
    // So we removed the previous ResizeObserver on .mad-navbar__section / #wpadminbar.

    window.madSingleProductImageGallery.initialized = true;
  });
});
